import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, HostListener } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-cc-message-center',
  templateUrl: './cc-message-center.component.html',
  styleUrls: ['./cc-message-center.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CcMessageCenterComponent implements OnInit {
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setMessageHeight();
  }

  //Variables Declaration
  @Output() backToHomeClicked = new EventEmitter<void>();
  @Output() readMessageClicked = new EventEmitter<void>();
  @Output() pinnedMessageClicked = new EventEmitter<{ messageObj: any; isPin: boolean}>();
  @Input() messageCenterMessages: any[];

  constructor() { }

  ngOnInit(): void {
    this.setMessageHeight();
  }

  setMessageHeight() {
    const templateHeight = window.innerHeight - 220;

    $('.messageCenterDetail').css('max-height', templateHeight + 'px');
  }

  backToHome() {
    this.backToHomeClicked.emit();
  }

  getFormattedMessageDate(date: Date): string {
    const dateFormat = new Date(date); // CST (UTC-6)
    let formattedDate = dateFormat.toLocaleString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/Chicago'
    });
    return formattedDate.replace(/at/gi, "").replace(/,/g, "").toUpperCase();
  }

  readMessage(messageObj) {
    this.readMessageClicked.emit(messageObj);
  }

  pinUnPinMessage(message, isPinned) {
    const pinnedValues = { messageObj: message, isPin: isPinned };
    this.pinnedMessageClicked.emit(pinnedValues);
  }
}
